module.exports = __webpack_public_path__ + "static/media/rocket.a8fe46e0.png";